import { SaveToBuyerList } from "./SaveToBuyerList";
import { SaveToCompetitorOrPartner } from "./SaveToCompetitorOrPartner";
import { SaveToNoticeList } from "./SaveToNoticeList";

export type ListEntities = "notice" | "buyer" | "supplier";
type Props = {
  entityIds: string[];
  entityType: ListEntities;
  isCreateFormOpen: boolean;
  onToggleCreateForm: (isCreateFormOpen: boolean) => void;
};
export function SaveToLists({
  entityIds,
  entityType,
  isCreateFormOpen,
  onToggleCreateForm,
}: Props) {
  switch (entityType) {
    case "notice":
      // TODO: When we allow saving multiple notices to
      // a single list we will need to move lists over to `entityIds`
      return (
        <SaveToNoticeList
          entityId={entityIds[0]}
          isCreateFormOpen={isCreateFormOpen}
          onToggleCreateForm={onToggleCreateForm}
        />
      );
    case "buyer":
      return (
        <SaveToBuyerList
          buyerIds={entityIds}
          isCreateFormOpen={isCreateFormOpen}
          onToggleCreateForm={onToggleCreateForm}
        />
      );
    case "supplier":
      return (
        <SaveToCompetitorOrPartner
          supplierGuids={entityIds}
          isCreateFormOpen={isCreateFormOpen}
          onToggleCreateForm={onToggleCreateForm}
        />
      );
    default:
      return null;
  }
}
